// utils/mediaUtils.js
export function isVideoFile(url) {
    if (!url) return false;
  
    try {
      // Remove query parameters
      const cleanUrl = new URL(url).pathname; // Extract only the path part
  
      // Extract file extension (last part after ".")
      const ext = cleanUrl.split('.').pop().toLowerCase();
  
      // Common video extensions
      const videoExtensions = ['mp4', 'mov', 'avi', 'webm', 'mkv'];
  
      return videoExtensions.includes(ext);
    } catch (error) {
      console.error("Invalid URL:", url);
      return false;
    }
  }
  